import { useTranslation } from 'react-i18next'

/**
 * The quick-study Other rollup's printed name, in the viewer's language (plots plan S).
 * The analysis stamps the rollup with `is_other` and an English title; the app prints
 * this word instead, so a Spanish study reads "Otros", never "Other".
 */
export function useThemeOtherLabel(): string {
  const { t } = useTranslation('app')

  return t('quickStudyChrome.themeOther')
}

/** The Other rollups' hover descriptions, in the viewer's language (the analysis stamps
 *  English ones). `mixed`: the monadic "Other / mixed" bucket (answers no shared theme
 *  took); `floor`: the pooled "Other" rollup (mentions below the reporting floor). */
export interface ThemeOtherDescriptions {
  mixed: string
  floor: string
}

export function useThemeOtherDescriptions(): ThemeOtherDescriptions {
  const { t } = useTranslation('app')

  return {
    mixed: t('quickStudyChrome.themeOtherDescription'),
    floor: t('quickStudyChrome.themeOtherFloorDescription'),
  }
}
